export function initFileResume(){
    const input = document.getElementById("file-resume") as HTMLInputElement | null;
    const dropArea = document.querySelector(".file-resume-label") as HTMLElement | null;
    const fileListContainer = document.querySelector(".file-resume") as HTMLElement | null;

    const allowedExt: string[] = ["pdf", "docx", "doc", "pptx"];

    const icons: Record<string, string> = {
        pdf: "images/pdf.svg",
        docx: "images/doc.svg",
        doc: "images/doc.svg",
        pptx: "images/ppt.svg"
    };

// Форматирование размера файла
    function formatSize(bytes: number): string {
        if (bytes < 1024) return bytes + " Б";
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " кБ";
        return (bytes / (1024 * 1024)).toFixed(1) + " МБ";
    }

// Создание элемента файла
    function createFileItem(file: File): HTMLElement | null {
        const ext = file.name.split(".").pop()?.toLowerCase() || "";
        if (!allowedExt.includes(ext)) {
            alert("Недопустимый формат: " + file.name);
            return null;
        }

        const item = document.createElement("div");
        item.className = "file-resume__item";
        item.innerHTML = `
      <div class="file-resume__content">
        <div class="file-resume__format">
          <img src="${icons[ext] || 'images/doc.svg'}" alt="">
        </div>
        <div class="file-resume__main">
          <div class="size-14 fw-600">${file.name}</div>
          <div class="file-resume-info">размер файла: ${formatSize(file.size)}</div>
        </div>
      </div>
      <button class="file-resume__delete icon">
        <svg><use xlink:href="images/sprite.svg#icon-Delete"></use></svg>
</button>
    `;

        const deleteBtn = item.querySelector(".file-resume__delete") as HTMLElement | null;
        if (deleteBtn) {
            deleteBtn.addEventListener("click", () => {
                item.remove();
            });
        }

        return item;
    }

// Добавление файлов
    function handleFiles(files: FileList | null): void {
        if (!files || !fileListContainer) return;
        Array.from(files).forEach(file => {
            const item = createFileItem(file);
            if (item) fileListContainer.appendChild(item);
        });
    }

    if (fileListContainer && input && dropArea) {
        // Загрузка через input
        input.addEventListener("change", (e: Event) => {
            const target = e.target as HTMLInputElement;
            handleFiles(target.files);
            if (input) input.value = ""; // чтобы можно было выбрать тот же файл повторно
        });

        // Drag & Drop
        ["dragenter", "dragover"].forEach(evt =>
            dropArea.addEventListener(evt, e => {
                e.preventDefault();
                dropArea.classList.add("dragover");
            })
        );
        ["dragleave", "drop"].forEach(evt =>
            dropArea.addEventListener(evt, e => {
                e.preventDefault();
                dropArea.classList.remove("dragover");
            })
        );

        dropArea.addEventListener("drop", (e: DragEvent) => {
            e.preventDefault();
            handleFiles(e.dataTransfer?.files || null);
        });
    }

}